import { createGlobalStyle } from "styled-components";
import styled, { keyframes } from "styled-components";
import * as Dialog from "@radix-ui/react-dialog";

export const BlockCollectionModalNonFullscreenStyle = createGlobalStyle`
  .cemboo-video-modal-nonfullscreen .modal-dialog {
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    margin: 0 !important;
  }
  .cemboo-video-modal-nonfullscreen .modal-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .cemboo-video-modal-nonfullscreen .modal-body {
    flex: 1 1 auto;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    padding: 0;
  }
`;

export const HeaderButton = styled.button`
    margin-right: 16px;
    font-size: 13px;
    font-weight: normal;
    color: #fff;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.4);
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

export const LoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px;
`;

export const Spinner = styled.div`
    width: 40px;
    height: 40px;
    border: 3px solid rgba(255, 255, 255, 0.2);
    border-top-color: #fff;
    border-radius: 50%;
    animation: ${spin} 0.7s linear infinite;
`;

export const ModalHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const ModalHeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const PlaylistsCollectionStyled = styled.div``

const fadeIn    = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const fadeOut   = keyframes`from { opacity: 1; } to { opacity: 0; }`;
const slideUp   = keyframes`from { transform: translateY(2%); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;
const slideDown = keyframes`from { transform: translateY(0); opacity: 1; } to { transform: translateY(2%); opacity: 0; }`;

export const DialogOverlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    z-index: 999999998;

    &[data-state="open"]   { animation: ${fadeIn}   200ms ease forwards; }
    &[data-state="closed"] {
        animation: ${fadeOut} 150ms ease forwards;
        pointer-events: none;
    }
`;

export const DialogContent = styled(Dialog.Content)<{ $nonFullscreen?: boolean }>`
    position: fixed;
    display: flex;
    flex-direction: column;
    background: #000;
    z-index: 999999999;
    overflow: hidden;

    ${({ $nonFullscreen }) =>
        $nonFullscreen
            ? `
        width: 60vw;
        height: 80vh;
        top: 10vh;
        left: 0;
        right: 0;
        margin: auto;
        max-width: none;
    `
            : `
        inset: 0;
    `}

    &[data-state="open"]   { animation: ${slideUp}   200ms ease forwards; }
    &[data-state="closed"] {
        animation: ${slideDown} 150ms ease forwards;
        pointer-events: none;
    }

    &:focus { outline: none; }
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    background: #111;
    flex-shrink: 0;
    font-family: var(--amplify-fonts-default-variable);
`;

export const ModalTitle = styled(Dialog.Title)`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
`;

export const CloseButton = styled(Dialog.Close)`
    background: transparent;
    border: none;
    color: #fff;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
    opacity: 0.7;

    &:hover { opacity: 1; }
`;

export const ModalBody = styled.div`
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;

    & > * {
        width: 100% !important;
        height: 100% !important;
    }
`;
